var render = function render(){
  var _vm$getSelectedExperi, _vm$targetNode, _vm$targetNode$proper, _vm$targetNode2, _vm$targetNode2$prope, _vm$getSelectedExperi2;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.visible,
      expression: "visible"
    }]
  }, [_c('div', {
    staticClass: "popup_wrap experimentType"
  }, [_c('div', {
    staticClass: "popup_title"
  }, [_c('p', [_c('span', {
    attrs: {
      "id": "node_title"
    }
  }, [_vm._v(_vm._s((_vm$getSelectedExperi = _vm.getSelectedExperiment) === null || _vm$getSelectedExperi === void 0 ? void 0 : _vm$getSelectedExperi.experimentName) + " 상세보기 ")])]), _c('a', {
    staticClass: "_command[CmmComm.closeLayer]"
  }, [_c('div', {
    staticClass: "btn_close",
    attrs: {
      "id": "popup_close",
      "title": "Close"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._m(0)])])]), _c('div', {
    staticClass: "popup_content1"
  }, [_c('div', {
    staticClass: "node_order_wrap"
  }, [_c('div', {
    staticClass: "node_order_box_middle"
  }, [_c('h4', {
    staticClass: "node_order_tit"
  }, [_vm._v("타이틀")]), _c('div', {
    staticClass: "node_name_box"
  }, [_c('div', {
    staticClass: "box_stitle2 node_title W80",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.input.experimentName,
      expression: "input.experimentName"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "text",
      "data-key": "input",
      "disabled": _vm.getExperimentResultMode == 'readOnly' && _vm.mode == 'experiment' || _vm.getProcessReadOnly && _vm.mode == 'process'
    },
    domProps: {
      "value": _vm.input.experimentName
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) return;

        _vm.$set(_vm.input, "experimentName", $event.target.value);
      }, function ($event) {
        return _vm.inputListener($event, 'experimentName');
      }],
      "keydown": function ($event) {
        return _vm.keydownListener($event, 'experimentName');
      }
    }
  })])]), _vm.selectedExperimentType != "DEFAULT" && _vm.selectedExperimentType != "RELEASE" ? _c('h4', {
    staticClass: "node_order_tit"
  }, [_vm._v(" 공유여부")]) : _vm._e(), _vm.selectedExperimentType != "DEFAULT" && _vm.selectedExperimentType != "RELEASE" ? _c('div', {
    staticClass: "node_name_box"
  }, [_c('div', {
    staticClass: "node_title W80"
  }, [_vm.selectedExperimentType == "DEFAULT" && _vm.getExperimentTypeSaveFlag == "update" ? _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.input.experimentType,
      expression: "input.experimentType"
    }],
    attrs: {
      "type": "radio",
      "name": "experimentType",
      "id": "DEFAULT",
      "value": "DEFAULT"
    },
    domProps: {
      "checked": _vm._q(_vm.input.experimentType, "DEFAULT")
    },
    on: {
      "change": function ($event) {
        return _vm.$set(_vm.input, "experimentType", "DEFAULT");
      }
    }
  }), _vm._m(1)]) : _vm._e(), _vm.selectedExperimentType == "RELEASE" && _vm.getExperimentTypeSaveFlag == "update" ? _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.input.experimentType,
      expression: "input.experimentType"
    }],
    attrs: {
      "type": "radio",
      "name": "experimentType",
      "id": "RELEASE",
      "value": "RELEASE"
    },
    domProps: {
      "checked": _vm._q(_vm.input.experimentType, "RELEASE")
    },
    on: {
      "change": function ($event) {
        return _vm.$set(_vm.input, "experimentType", "RELEASE");
      }
    }
  }), _vm._m(2)]) : _vm._e(), _vm.selectedExperimentType != "RELEASE" && _vm.selectedExperimentType != "DEFAULT" ? _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.input.experimentType,
      expression: "input.experimentType"
    }],
    attrs: {
      "type": "radio",
      "name": "experimentType",
      "id": "SHARE",
      "value": "SHARE"
    },
    domProps: {
      "checked": _vm._q(_vm.input.experimentType, "SHARE")
    },
    on: {
      "change": function ($event) {
        return _vm.$set(_vm.input, "experimentType", "SHARE");
      }
    }
  }), _vm._m(3), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.input.experimentType,
      expression: "input.experimentType"
    }],
    attrs: {
      "type": "radio",
      "name": "experimentType",
      "id": "CUSTOM",
      "value": "CUSTOM"
    },
    domProps: {
      "checked": _vm._q(_vm.input.experimentType, "CUSTOM")
    },
    on: {
      "change": function ($event) {
        return _vm.$set(_vm.input, "experimentType", "CUSTOM");
      }
    }
  }), _vm._m(4)]) : _vm._e()])]) : _vm._e(), _c('h4', {
    staticClass: "node_order_tit"
  }, [_vm._v("노드 목록")]), _vm.mode == 'experiment' ? _c('div', {
    staticClass: "marking_top"
  }, [_c('div', {
    staticClass: "marking_top_left"
  }, [_c('button', {
    staticClass: "btn_basic",
    attrs: {
      "title": "전체노드"
    },
    on: {
      "click": _vm.saveCustomSettings
    }
  }, [_vm._v("커스텀설정저장")])]), _c('div', {
    staticClass: "marking_top_right"
  })]) : _vm._e(), _c('ul', {
    staticClass: "node_marking_list"
  }, _vm._l(_vm.nodeArray, function (node, idx) {
    return _c('li', {
      key: idx,
      class: {
        'on': _vm.targetNode.key == node.key
      },
      style: {
        'background-color': node.backgroundColor
      },
      attrs: {
        "draggable": true
      },
      on: {
        "dragstart": function ($event) {
          return _vm.dragStart($event, idx, 'node');
        },
        "dragover": function ($event) {
          $event.preventDefault();
        },
        "drop": function ($event) {
          return _vm.dragDrop($event, idx, 'node');
        }
      }
    }, [_c('div', {
      staticClass: "marking_nodetitle_wrap"
    }, [_vm.mode == 'experiment' ? _c('div', {
      staticClass: "marking_area_fold_area"
    }, [_c('a', {
      staticClass: "marking_area",
      class: {
        'check_on': node.nodeVisible
      },
      style: {
        'background-color': node.backgroundColor
      },
      on: {
        "click": function ($event) {
          return _vm.nodeVisibleCheck(node.key);
        }
      }
    })]) : _vm._e(), _c('a', {
      staticClass: "marking_nodetitle",
      on: {
        "click": function ($event) {
          return _vm.nodeClick(node.key);
        }
      }
    }, [_vm._v("[" + _vm._s(node.nodeOrder) + "]. " + _vm._s(node.text))]), _vm.mode == 'experiment' ? _c('div', {
      staticClass: "marking_area_fold_area"
    }, [_c('button', {
      staticClass: "node_fold btn_node_change",
      staticStyle: {
        "background-color": "white"
      },
      attrs: {
        "title": "드래그"
      }
    })]) : _vm._e()])]);
  }), 0)]), _c('div', {
    staticClass: "node_order_box_right"
  }, [((_vm$targetNode = _vm.targetNode) === null || _vm$targetNode === void 0 ? void 0 : (_vm$targetNode$proper = _vm$targetNode.propertyArray) === null || _vm$targetNode$proper === void 0 ? void 0 : _vm$targetNode$proper.length) == 0 ? _c('div', [_vm._m(5)]) : _c('div', [_c('div', {
    staticClass: "search_form_wrap"
  }, [_c('ul', {
    staticClass: "search_form_list"
  }, [_c('li', {
    staticStyle: {
      "width": "87.5%"
    }
  }, [_c('div', {
    staticClass: "inpt_sch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.searchQuery,
      expression: "searchQuery"
    }],
    staticClass: "form_control",
    staticStyle: {
      "background-color": "white"
    },
    attrs: {
      "type": "text",
      "data-key": "searchQuery",
      "placeholder": "속성명 검색을 할수있어요."
    },
    domProps: {
      "value": _vm.searchQuery
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) return;
        _vm.searchQuery = $event.target.value;
      }, function ($event) {
        return _vm.inputListener($event, 'searchQuery');
      }],
      "keydown": function ($event) {
        return _vm.keydownListener($event, 'searchQuery');
      }
    }
  }), _c('button', {
    attrs: {
      "type": "button"
    }
  })])]), _c('li', {
    staticStyle: {
      "width": "12.5%"
    }
  }, [_c('div', {
    staticClass: "inpt_sch"
  }, [_c('button', {
    staticClass: "eraser",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetSearchQuery
    }
  })])])])]), _c('p', {
    staticStyle: {
      "font-size": "14px",
      "text-align": "right"
    }
  }, [_vm._v(" 검색조건 결과 : " + _vm._s(_vm.targetNodeSearchArray.length) + "개 / 총 : " + _vm._s((_vm$targetNode2 = _vm.targetNode) === null || _vm$targetNode2 === void 0 ? void 0 : (_vm$targetNode2$prope = _vm$targetNode2.propertyArray) === null || _vm$targetNode2$prope === void 0 ? void 0 : _vm$targetNode2$prope.length) + "개 ")]), _vm._l(_vm.targetNodeSearchArray.filter(function (attr) {
    return attr.searchFlag;
  }), function (attr, index) {
    var _attr$propertyVocabul, _attr$propertyClass, _attr$propertyClass2;

    return _c('div', {
      key: index,
      staticClass: "node_result_box",
      attrs: {
        "draggable": true
      },
      on: {
        "dragstart": function ($event) {
          return _vm.dragStart($event, index, 'attr');
        },
        "dragover": function ($event) {
          $event.preventDefault();
        },
        "drop": function ($event) {
          return _vm.dragDrop($event, index, 'attr');
        }
      }
    }, [_c('h4', {
      staticClass: "site_detail_tit"
    }, [_vm._v(" " + _vm._s(attr.propertyName) + " "), attr.propertyDefine != null && attr.propertyDefine != '' ? _c('div', {
      directives: [{
        name: "b-toggle",
        rawName: "v-b-toggle",
        value: `experiment-type-collapse-${index}`,
        expression: "`experiment-type-collapse-${index}`"
      }],
      staticClass: "tooltip_box",
      attrs: {
        "title": "속성설명을 보려면 클릭해주세요."
      }
    }, [_c('span', {
      staticClass: "tooltip_ico"
    })]) : _vm._e(), _vm.mode == 'experiment' ? _c('div', {
      staticClass: "node_result_box_btn"
    }, [_c('a', {
      staticClass: "btn_node_check",
      class: attr.propertyVisible == true ? 'on' : 'off',
      on: {
        "click": function ($event) {
          return _vm.attrVisibleCheck(attr.processPropertyId);
        }
      }
    })]) : _vm._e()]), _c('div', {
      staticClass: "site_detail_con"
    }, [_c('h4', {
      staticClass: "site_detail_con",
      staticStyle: {
        "margin-bottom": "5px"
      }
    }, [_vm._v("단위 : " + _vm._s(attr.propertyUnit != null && attr.propertyUnit != "" ? attr.propertyUnit : "없음") + " | 타입 : " + _vm._s(attr.propertyType != null ? attr.propertyType == _vm.PROPERTY_TYPE.STRING.value ? 'TEXT' : attr.propertyType : "-"))]), !_vm.isDistrictValid.includes(attr.propertyType) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: attr.propertyValue,
        expression: "attr.propertyValue"
      }],
      staticClass: "W100",
      attrs: {
        "type": "text",
        "data-key": "experimentTypeAttribute",
        "data-attributeId": attr.processPropertyId,
        "disabled": _vm.getExperimentResultMode == 'readOnly' && _vm.mode == 'experiment' || _vm.getProcessReadOnly && _vm.mode == 'process'
      },
      domProps: {
        "value": attr.propertyValue
      },
      on: {
        "input": [function ($event) {
          if ($event.target.composing) return;

          _vm.$set(attr, "propertyValue", $event.target.value);
        }, function ($event) {
          return _vm.inputListener($event, attr.processPropertyId);
        }],
        "keydown": function ($event) {
          return _vm.keydownListener($event, attr.processPropertyId);
        }
      }
    }) : _vm._e()]), !_vm.strIsNull((_attr$propertyVocabul = attr.propertyVocabulary) === null || _attr$propertyVocabul === void 0 ? void 0 : _attr$propertyVocabul.code) ? _c('h4', {
      staticClass: "custom_site_detail_con"
    }, [_vm._v(" 어휘번호 : " + _vm._s(_vm.createViewVocabularyString(attr.propertyVocabulary)) + " ")]) : _vm._e(), !_vm.strIsNull((_attr$propertyClass = attr.propertyClass) === null || _attr$propertyClass === void 0 ? void 0 : _attr$propertyClass.name) ? _c('h4', {
      staticClass: "custom_site_detail_con"
    }, [_vm._v("class : " + _vm._s((_attr$propertyClass2 = attr.propertyClass) === null || _attr$propertyClass2 === void 0 ? void 0 : _attr$propertyClass2.name) + " ")]) : _vm._e(), attr.propertyDefine != null && attr.propertyDefine != '' ? _c('div', [_c('b-collapse', {
      staticClass: "mt-2",
      staticStyle: {
        "cursor": "default"
      },
      attrs: {
        "id": `experiment-type-collapse-${index}`
      }
    }, [_c('b-card', {
      on: {
        "click": function ($event) {
          $event.stopPropagation();
        }
      }
    }, [_c('p', {
      staticStyle: {
        "white-space": "pre-line",
        "text-align": "left",
        "font-size": "13px",
        "font-weight": "bold"
      }
    }, [_vm._v(_vm._s(attr.propertyDefine))])])], 1)], 1) : _vm._e()]);
  }), _vm.targetNodeSearchArray.filter(function (attr) {
    return attr.searchFlag;
  }).length == 0 ? _c('div', [_vm._m(6)]) : _vm._e()], 2)])])]), _c('div', {
    staticClass: "popup_footer"
  }, [_vm.getExperimentTypeSaveFlag == 'create' ? _c('a', {
    staticClass: "btn_type1",
    on: {
      "click": _vm.saveExperimentType
    }
  }, [_vm._v("생성")]) : _vm._e(), (_vm.getExperimentResultMode == 'edit' || !_vm.getProcessReadOnly && (_vm.user.committee || _vm.user.admin) && _vm.$route.query.menuType == 'manager') && _vm.getExperimentTypeSaveFlag == 'update' && (_vm.selectedExperimentType == 'SHARE' || _vm.selectedExperimentType == 'CUSTOM' && ((_vm$getSelectedExperi2 = _vm.getSelectedExperiment) === null || _vm$getSelectedExperi2 === void 0 ? void 0 : _vm$getSelectedExperi2.userId) == _vm.user.id || _vm.selectedExperimentType == 'RELEASE' && (_vm.user.committee || _vm.user.admin) || _vm.selectedExperimentType == 'DEFAULT' && (_vm.user.committee || _vm.user.admin)) ? _c('a', {
    staticClass: "btn_type1",
    on: {
      "click": _vm.saveExperimentType
    }
  }, [_vm._v("저장")]) : _vm._e(), _c('a', {
    staticClass: "btn_type3",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("닫기")])])]), _c('div', {
    staticClass: "mask_wrap",
    staticStyle: {
      "display": "block"
    }
  }), _c('Loading', {
    attrs: {
      "visible": _vm.loading,
      "type": "fixed"
    }
  })], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "btn_close_box"
  }, [_c('span'), _c('span')]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    attrs: {
      "for": "DEFAULT"
    }
  }, [_c('span', [_vm._v("공정도 기본값")])]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    attrs: {
      "for": "RELEASE"
    }
  }, [_c('span', [_vm._v("공정도 기본값")])]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    attrs: {
      "for": "SHARE"
    }
  }, [_c('span', [_vm._v("공유O")])]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    attrs: {
      "for": "CUSTOM"
    }
  }, [_c('span', [_vm._v("공유X")])]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "nodata_txt"
  }, [_c('p', [_vm._v("공정도 적용속성이 존재하지 않는 노드입니다.")])]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "nodata_txt"
  }, [_c('p', [_vm._v("검색된 속성이 없습니다.")])]);

}]

export { render, staticRenderFns }